module.exports = __webpack_public_path__ + "static/img/Reid_M.7710a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reid_M.jpg
// module id = +Ilk
// module chunks = 0